import { graphql } from '../../../gql';

export const LIKE_POST_MUTATION = graphql(`
  mutation LikePost($input: LikePostInput!) {
    likePost(input: $input) { success postId likeCount }
  }
`);

export const UNLIKE_POST_MUTATION = graphql(`
  mutation UnlikePost($input: UnlikePostInput!) {
    unlikePost(input: $input) { success postId likeCount }
  }
`);
